import { useQuery } from '@tanstack/react-query';
import type {
  RequestRefundableAmount,
  RequestRefundableAmountResponse,
} from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export const useRequestRefundableAmount = (
  requestParams: RequestRefundableAmount
) => {
  const result = useQuery<RequestRefundableAmountResponse>({
    queryKey: [clientKeys.useRequestRefundableAmount, requestParams],
    queryFn: async () =>
      await falconClient.post(
        `${baseUrl}/resource_approvals/${requestParams.resource_approval_uuid}/refundable_amount`,
        {
          refund_amount_requested: requestParams.refund_amount_requested,
          refund_request_uuid: requestParams.refund_request_uuid,
        }
      ),
  });

  const requestRefundableAmount: Partial<RequestRefundableAmountResponse> =
    result.data || {};

  return { requestRefundableAmount, ...result };
};
